/**
 * Pack-selector quantity copy: squeeze bottles stay "bottle",
 * powder + creamer pouches → pouch, stick packs → box.
 */
(function (root, factory) {
  var api = factory();
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
  }
  root.JoiPackCardLabels = api;
})(typeof window !== 'undefined' ? window : typeof globalThis !== 'undefined' ? globalThis : this, function () {
  var KNOWN = { pouch: true, box: true, bottle: true, pail: true };

  function normalizeHandle(handle) {
    return String(handle || '')
      .replace(/^\/products\//i, '')
      .split(/[?#]/)[0]
      .replace(/\/+$/, '')
      .toLowerCase();
  }

  function unitFromHandle(handle) {
    var h = normalizeHandle(handle);
    if (!h) return '';

    if (
      /single-serve/.test(h) ||
      /10ct/.test(h) ||
      /-singles(?:-|$)/.test(h) ||
      /singles$/.test(h) ||
      /-carton/.test(h) ||
      /variety-3-pack/.test(h)
    ) {
      return 'box';
    }

    // Stick-pack multi-box SKUs (e.g. oat-creamer-hazelnut-3-pack).
    if (/-3-pack/.test(h) && /(creamer|instant-organic-oat-milk)/.test(h)) {
      return 'box';
    }

    if (
      /oat-milk-creamer/.test(h) ||
      /oat-creamer-hazelnut/.test(h) ||
      /oat-creamer-french-vanilla/.test(h) ||
      /cashew-hazelnut-oat-creamer/.test(h) ||
      /powder/.test(h) ||
      /instant-organic-oat-milk/.test(h) ||
      /organic-soy-milk/.test(h)
    ) {
      return 'pouch';
    }

    return '';
  }

  function isBulkHandle(handle) {
    var h = normalizeHandle(handle);
    if (!h) return false;
    if (h.indexOf('-pack') !== -1 && h.indexOf('bulk') === -1) return false;
    return /bulk/.test(h) || /pail/.test(h) || /-base-1(?:-|$)/.test(h);
  }

  function unitFromAttr(value) {
    var unit = String(value || '').toLowerCase().trim();
    if (unit === 'bag') return 'pouch';
    return KNOWN[unit] ? unit : '';
  }

  function unitForList(list) {
    if (!list || !list.getAttribute) return 'bottle';
    var active = list.getAttribute('data-active-handle');
    // Bulk pails sit beside bottle/pouch packs — don't relabel the whole list.
    if (!isBulkHandle(active)) {
      var fromHandle = unitFromHandle(active);
      if (fromHandle) return fromHandle;
    }
    return unitFromAttr(list.getAttribute('data-pack-unit')) || 'bottle';
  }

  function unitForCard(list, li) {
    if (li && li.getAttribute && li.getAttribute('data-size') === 'bulk') return 'pail';
    if (li && li.classList && li.classList.contains('bulk')) return 'pail';
    var titleEl = li && li.querySelector && li.querySelector('.info-text-sm > p');
    var title = titleEl ? String(titleEl.textContent || '') : '';
    if (/bulk/i.test(title)) return 'pail';
    var href = '';
    var link = li && li.querySelector && li.querySelector('a[href*="/products/"]');
    if (link) href = link.getAttribute('href') || '';
    if (isBulkHandle(href)) return 'pail';
    return unitForList(list);
  }

  var PLURAL = { pouch: 'pouches', box: 'boxes', bottle: 'bottles', pail: 'pails' };

  function countPhrase(count, noun) {
    var n = Number(count);
    var unit = String(noun || '').toLowerCase();
    if (!n || n < 1 || !KNOWN[unit]) return '';
    if (n === 1) return '1 ' + unit;
    return n + ' ' + PLURAL[unit];
  }

  return {
    normalizeHandle: normalizeHandle,
    unitFromHandle: unitFromHandle,
    isBulkHandle: isBulkHandle,
    unitFromAttr: unitFromAttr,
    unitForList: unitForList,
    unitForCard: unitForCard,
    countPhrase: countPhrase
  };
});
